<template>
  <div class="app">
    <!-- 手机端内容 -->
    <div class="mobile_app_page">
      <img width="100%" src="../assets/img/mobile/app.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1170px) {
  .pc_app_page {
    display: none;
  }
  .mobile_app_page {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app.vue